import React from 'react';
import { translate } from 'react-i18next';
import Actions from 'notifications_historic/components/list/NotificationsHistoricActions';
import { formatTimeStamp } from 'lib/util';

const NotificationsHistoricListRow = ({
  notificationHistoric,
  company,
  subcompany,
  permissions,
  t,
  handleToggle,
}) => {
  return (
    <tr>
      {/* <td>{notificationHistoric.key}</td> */}
      <td>{formatTimeStamp(notificationHistoric.date)}</td>
      <td>{t(notificationHistoric.name)}</td>
      <td>{notificationHistoric.subject}</td>
      <td>{notificationHistoric._usersToNotify.length}</td>
      {/* <td>{notificationHistoric.elements.length}</td> */}
      {/* <td className="text-center">{t(notificationHistoric.active ? "common.yes" : "common.no")}</td> */}
      <td className="text-center">
        <Actions
          permissions={permissions}
          notificationHistoric={notificationHistoric}
          company={company}
          subcompany={subcompany}
          handleToggle={handleToggle}
        />
      </td>
    </tr>
  );
};

export default translate()(NotificationsHistoricListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/components/list/NotificationsHistoricListRow.js